import { useState } from 'react';
import { MultiValue } from 'react-select';

import { AutocompleteOptionForHookForm } from '@savgroup-front-common/types';

import { NumericFacet, NumericRubric } from '../../Datatable.types';

export const useFilterNumeric = ({
  filter,
  onChange,
}: {
  filter: NumericRubric;
  onChange?: (selectedFilter: NumericRubric) => void;
}) => {
  const [filtersNumericValue, setFiltersNumericValue] = useState<
    MultiValue<AutocompleteOptionForHookForm<NumericFacet>>
  >([]);

  const buildFiltersNumericOptions = (
    facets: NumericFacet[],
  ): AutocompleteOptionForHookForm<NumericFacet>[] => {
    return facets.map((facet) => ({
      value: facet.name || '',
      label: `${facet.name} - ( ${facet.count} )`,
      data: facet,
    }));
  };

  const handleFilterNumericSelected = (
    selectedValues: MultiValue<AutocompleteOptionForHookForm<NumericFacet>>,
  ) => {
    setFiltersNumericValue(selectedValues);

    const selectedFilter = {
      name: filter.name,
      label: filter.label,
      facets: selectedValues.map((selectedValue) => ({
        ...selectedValue.data,
        included: true,
      })),
      type: filter.type,
      filterName: `filterDefault_${filter.name}`,
    };

    if (onChange) {
      onChange(selectedFilter);
    }
  };

  return {
    filtersNumericValue,
    buildFiltersNumericOptions,
    handleFilterNumericSelected,
  };
};
